import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./visibility.svg?react";

export const VisibilityIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
